import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../components/Button";
import { EmptyState } from "../components/States";
import { PageContainer } from "../components/Card";

/**
 * The 404 the old app never had - every unmatched URL used to render the shell with a blank panel,
 * which is indistinguishable from a screen that failed to load.
 */
export const NotFound: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <PageContainer>
            <EmptyState
                icon={["fad", "compass"]}
                title="That page does not exist"
                hint={
                    <>
                        Nothing is routed at <code className="font-mono text-xs">{location.pathname}</code>. If you followed a link from
                        elsewhere in the app, it is out of date.
                    </>
                }
                action={
                    <div className="flex gap-2">
                        <Button variant="outline-secondary" onClick={() => navigate(-1)}>
                            Go back
                        </Button>
                        <Button onClick={() => navigate("/")}>Dashboard</Button>
                    </div>
                }
            />
        </PageContainer>
    );
};

export default NotFound;
